import { Box, Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { NoCard } from '@uplift/icons';
import { Button } from '../../../Button';
import { EditableSectionContainer, EditableSectionContainerFixedEditAction, EditableSectionRow } from '../../../EditableSection';
import { useIsMobile, useL10n } from '@uplift/hooks';
import { useUserProfileQuery, useUserQuery } from '@uplift/queries';
import { useCurrentuser } from '@uplift/contexts';
import { Add } from '@mui/icons-material';


export type InsuranceEmptyProps = {
  onAddInsurance: () => void;
  userId: string;
};

export const InsuranceEmpty: React.VFC<InsuranceEmptyProps> = ({ onAddInsurance, userId }) => {
  const { classes } = useStyles();
  const l10n = useL10n();
  const isMobile = useIsMobile('sm');
  const { data: profile, isLoading: profileLoading } = useUserProfileQuery(userId);
  const { data: user } = useUserQuery(userId);


  const me = useCurrentuser();
  // const isMobile = useIsMobile('sm');

  const addInsuranceButton = (
    <Button
      color="secondary"
      onClick={() => onAddInsurance()}
      startIcon={isMobile ? <Add /> : undefined}
      variant="contained"
    >
      {l10n.accountSettings.addInsurance.addInsurance}
    </Button>
  );

  const content = (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      py={{ xs: 3, sm: 5 }}
      textAlign="center"
      px={2}
    >
      <Box mb={2}>
        <NoCard classes={{ root: classes.icon }} />
      </Box>
      <Box mb={1}>
        <Typography variant="h6" color="textSecondary">{l10n.accountSettings.insurance.noInsurance}</Typography>
      </Box>
      <Box mb={3}>
        <Typography>{l10n.accountSettings.addInsurance.onlyInsurancesAcceptedByCareTeam}</Typography>
      </Box>
      {isMobile ? null : (
        <Button
          color="secondary"
          variant="contained"
          onClick={onAddInsurance}
        >
          Add Insurance
        </Button>
      )}
    </Box>
  );

  const adminContent = (
    <EditableSectionContainer title="Active Insurance">
      <EditableSectionRow
        kind="custom"
        actions={isMobile ? undefined : addInsuranceButton}
        rowKey="addInsurance"
      >
        <Box display="flex" flexDirection="column" gap="1rem">
          <Typography>{l10n.accountSettings.addInsurance.adminOnlyInsurancesAccepted((profile?.preferredName || user?.firstName) ?? '')}</Typography>
          {isMobile ? addInsuranceButton : null}
        </Box>
      </EditableSectionRow>
    </EditableSectionContainer>
  );

  if (profileLoading) {
    return null;
  }
  return (
    <div>
      {
        me.role === 'superadmin'
          ? (
            <>
              {isMobile ? null : adminContent}
              {null}
            </>
          )
          : (
            <div>
              {isMobile ? null : (
                <Paper elevation={4}>
                  {content}
                </Paper>
              )}
              {isMobile ? (
                <>
                  {content}
                  <EditableSectionContainerFixedEditAction editButtonText="Add Insurance" onClick={onAddInsurance} />
                </>
              ) : null}
            </div>
          )}

    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  icon: {
    width: '60px',
    height: '60px',
    color: theme.palette.lightGold.contrastText
  }
}));
